"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _Structure = _interopRequireDefault(require("eventbrite_design_system/structure/Structure"));

var _CookieNotification = _interopRequireDefault(require("eventbrite_design_system/notification/CookieNotification"));

var _siteHeader = require("@eb/site-header");

var _siteFooter = require("@eb/site-footer");

var _http = require("js-utils/http");

var _gettext = _interopRequireDefault(require("js-utils/gettext"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SiteStructure =
/*#__PURE__*/
function (_Component) {
  _inherits(SiteStructure, _Component);

  function SiteStructure() {
    _classCallCheck(this, SiteStructure);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteStructure).apply(this, arguments));
  }

  _createClass(SiteStructure, [{
    key: "_getHeader",
    value: function _getHeader() {
      var _this$props = this.props,
          env = _this$props.env,
          request = _this$props.request,
          user = _this$props.user,
          globalHeader = _this$props.globalHeader,
          additionalHeaderContent = _this$props.additionalHeaderContent,
          hideSearchBar = _this$props.hideSearchBar,
          onSearchFocus = _this$props.onSearchFocus,
          showReportBugLinkInHeader = _this$props.showReportBugLinkInHeader;
      var header = globalHeader;
      var cookieHeader;

      if (env.isEmbeddedView) {
        return null;
      } // NOTE: We need to support retrieving the `user` object via an API
      // request in order to support varnish-cached pages for logged in users.
      // See EB-39986 for more details


      if ((0, _isUndefined.default)(header)) {
        header = _react.default.createElement(_siteHeader.SiteHeader, {
          env: env,
          request: request,
          user: user,
          onSearchSelect: _http.setWindowLocation,
          hideSearchBar: hideSearchBar,
          onSearchFocus: onSearchFocus,
          showReportBugLinkInHeader: showReportBugLinkInHeader
        });
      }

      if (env.showCookieHeader) {
        // TODO: this message should be moved to:
        // /eventbrite_design_system/src/molecules/notification/constants.js
        // and used as default values on /eventbrite_design_system/src/molecules/notification/CookieNotification.js
        var cookieMessage = (0, _gettext.default)("\n                Eventbrite, and certain approved third parties, use functional, analytical\n                and tracking cookies (or similar technologies) to understand your event preferences\n                and provide you with a customized experience. By closing this banner\n                or by continuing to use Eventbrite, you agree.");
        var cookiePolicyLink = '/cookies/';
        cookieHeader = _react.default.createElement(_CookieNotification.default, {
          message: cookieMessage,
          linkHref: cookiePolicyLink,
          cookieName: "acceptedCookieHeader"
        });
      }

      if (additionalHeaderContent || cookieHeader) {
        header = _react.default.createElement("div", null, cookieHeader, header, additionalHeaderContent);
      }

      return header;
    }
  }, {
    key: "_getFooter",
    value: function _getFooter() {
      var _this$props2 = this.props,
          env = _this$props2.env,
          user = _this$props2.user,
          footer = _this$props2.footer,
          footerLinks = _this$props2.footerLinks,
          showBrand = _this$props2.showBrand,
          showMarketingLinks = _this$props2.showMarketingLinks;

      if (env.isEmbeddedView) {
        return null;
      }

      if ((0, _isUndefined.default)(footer) && footerLinks) {
        footer = _react.default.createElement(_siteFooter.SiteFooter, {
          serverUrl: env.serverUrl,
          locales: env.locales,
          localeInfo: env.localeInfo,
          isUserAuthenticated: user.isAuthenticated,
          popularSearches: footerLinks.popularSearches,
          eventsToPlan: footerLinks.eventsToPlan,
          thirdFooterColumn: footerLinks.thirdFooterColumn,
          thirdFooterColumnName: footerLinks.thirdFooterColumnName,
          countries: footerLinks.countries,
          showBrand: showBrand,
          showMinimalLinks: footerLinks.showMinimalLinks,
          showMarketingLinks: showMarketingLinks,
          helpLinks: env.helpUrls,
          onLocaleChange: this._handleLocaleChange.bind(this)
        });
      }

      return footer;
    }
  }, {
    key: "_handleLocaleChange",
    value: function _handleLocaleChange(locale) {
      var serverUrl = this.props.env.serverUrl;
      (0, _http.setWindowLocation)("".concat(serverUrl, "/international/change_locale/?locale=").concat(locale));
    }
  }, {
    key: "render",
    value: function render() {
      var structurePassThruProps = _extends({}, this.props);

      if (structurePassThruProps.env.isEmbeddedView) {
        structurePassThruProps = _objectSpread({}, structurePassThruProps, {
          pageTitle: undefined,
          navItems: undefined,
          sideDrawerDescription: undefined
        });
      } // structurePassThruProps has to be placed last
      // in case of a specific page's need to override
      // header and/or footer


      return _react.default.createElement(_Structure.default, _extends({
        header: this._getHeader(),
        footer: this._getFooter()
      }, structurePassThruProps));
    }
  }]);

  return SiteStructure;
}(_react.Component);

exports.default = SiteStructure;

_defineProperty(SiteStructure, "propTypes", _objectSpread({}, _Structure.default.propTypes, {
  env: _constants.ENV_SHAPE_PROP_TYPE.isRequired,
  request: _constants.REQUEST_SHAPE_PROP_TYPE.isRequired,
  user: _constants.USER_SHAPE_PROP_TYPE.isRequired,
  globalHeader: _propTypes.default.node,
  additionalHeaderContent: _propTypes.default.node,
  footerLinks: _constants.FOOTER_LINKS_SHAPE_PROP_TYPE,
  showBrand: _propTypes.default.bool,
  showMarketingLinks: _propTypes.default.bool,
  hideSearchBar: _propTypes.default.bool,
  onSearchFocus: _propTypes.default.func
}));
//# sourceMappingURL=SiteStructure.js.map